/*
 * hy.frontend.core
 *
 * NOTE: this file is not subject to copyright transfer
 * UWAGA: plik nie objęty przekazaniem praw autorskich
 * © 2016 Hycom S.A.
 *
 */


define(['t3', 'hy/hy-module', 'hy/hy-utils', 'lodash', 'events', 'core/services/expander'], function(T3, BaseModule, hyutils, lodash, EVENTS) {

    'use strict';

    return BaseModule.addModule('core/modules/expander', function(context) {
        var options = context.element.options;
        var moduleEl,
            expanderService;

        return {
            init: function() {
                moduleEl = context.getElement();

                expanderService = context.getService('expander').create(moduleEl, options);
                expanderService.init(['click']);
            },

            destroy: function() {
                expanderService.destroy(moduleEl, options);
                expanderService = null;

                moduleEl = null;
            },

            messages: [
                EVENTS.modules.expander.toggle,
                EVENTS.modules.expander.open,
                EVENTS.modules.expander.close,
                EVENTS.modules.expander.next,
                EVENTS.modules.expander.prev,
                EVENTS.modules.expander.openall,
                EVENTS.modules.expander.closeall,
                EVENTS.modules.expander.loadHash
            ],

            onmessage: function(name, data) {
                switch (name) {
                    case EVENTS.modules.expander.toggle:
                        expanderService.toggleSection(data);
                        break;
                    case EVENTS.modules.expander.open:
                        expanderService.openDirectSelection(data);
                        break;
                    case EVENTS.modules.expander.close:
                        expanderService.collapseDirectSelection(data);
                        break;
                    case EVENTS.modules.expander.next:
                        expanderService.nextSection();
                        break;
                    case EVENTS.modules.expander.prev:
                        expanderService.prevSection();
                        break;
                    case EVENTS.modules.expander.openall:
                        expanderService.expandAllSection(data);
                        break;
                    case EVENTS.modules.expander.closeall:
                        expanderService.collapseAllSection(data);
                        break;
                    case EVENTS.modules.expander.loadHash:
                        expanderService.loadByHash(data);
                        break;
                    default:
                        break;
                }
            }
        };
    });
});